module.exports = __webpack_public_path__ + "static/img/sdab_qqhsdhz_one.060a063.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdab_qqhsdhz_one.png
// module id = 2R6q
// module chunks = 21